import { dev } from '$app/environment';
import { MapPlus } from '$internal/utils/map';
import type { Glob } from './types';

class ContentMap extends MapPlus<string, Glob> {
	constructor() {
		super();

		const globs = import.meta.glob<Glob>('../../content/**/*.md', {
			eager: true
		});

		for (const relativePath in globs) {
			const pathname = ContentMap.createWebsitePathname(relativePath);
			if (pathname.startsWith('_')) {
				if (dev) this.set(pathname.substring(1), globs[relativePath]);
				continue;
			}
			this.set(pathname, globs[relativePath]);
		}
	}

	static createWebsitePathname(relativePath: string): string {
		const norm = relativePath.split('/').filter((part) => part !== '..');
		norm.shift();

		let last = norm.pop();
		if (!last) throw new Error(`Could not process the path: ${relativePath}`);

		last = last.substring(0, last.lastIndexOf('.'));

		if (last !== 'index') norm.push(last);

		return norm.join('/');
	}

	public byPrefix(prefix: string): [string, Glob][] {
		const found: [string, Glob][] = [];
		for (const entry of this.entries()) {
			if (entry[0].startsWith(prefix) && entry[0].length > prefix.length) found.push(entry);
		}
		return found;
	}
}

export const contentsMap = new ContentMap();
